import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';
import { Location } from '@angular/common';
import{ Router } from '@angular/router';

@Component({
  selector: 'app-checkerdata',
  templateUrl: './checkerdata.component.html',
  styleUrls: ['./checkerdata.component.scss']
})
export class CheckerdataComponent implements OnInit {

  constructor(public appservice:AppService,public location:Location,public router:Router) { }
approveEmployee(data:any){
  this.appservice.Editcheckerdata=data;
  this.appservice.checkereditdata.employeecode=data;
  this.appservice.checkereditdata.status="Approved";
  this.appservice.checkereditdata.employeecode=data;
  this.appservice.checkereditdata.createdby=this.appservice.username;
  this.appservice.editchecker="approved";
  this.router.navigate(['/home/checkerreview']);
}

rejectEmployee(data:any){
  this.appservice.Editcheckerdata=data;
  this.appservice.checkereditdata.employeecode=data;
  this.appservice.checkereditdata.status="Rejected";
  this.appservice.checkereditdata.employeecode=data;
  this.appservice.checkereditdata.createdby=this.appservice.username;
  this.appservice.editchecker="rejected"
  this.router.navigate(['/home/checkerreview']);
}
  ngOnInit(): void {
    this.appservice.getcheckerdata();
  }

}
